<template>
	<div class="c-step-by-step__item-wrapper">
		<button
			@click="emit('expand', index)"
			class="c-step-by-step__heading-button"
			:aria-controls="contentId"
			:aria-expanded="isExpanded"
			data-step-by-step-activator
			:data-active="isExpanded"
			:aria-describedby="headingId"
			type="button"
		>
			<DsText
				html-element="span"
				text-type="heading-md"
				class="c-step-by-step__item-number"
			>
				<span class="c-step-by-step__button-area"></span>
				<span class="c-step-by-step__item-disc">
					{{ index }}
				</span>
			</DsText>
			<DsText
				class="c-step-by-step__heading-text"
				text-type="heading-lg"
				text-style="medium"
				html-element="span"
				:id="headingId"
			>
				{{ headline }}
			</DsText>
		</button>
		<div
			class="c-step-by-step__content"
			:id="contentId"
			:data-expanded="isExpanded"
			data-step-by-step-content
		>
			<div
				class="c-step-by-step__item-content-wrapper"
				data-item-content-wrapper
			>
				<div class="c-step-by-step__item-media" v-if="!isDesktop">
					<div
						v-if="externalVideoSource"
						class="c-step-by-step__video-container"
					>
						<step-by-step-video-item-loop
							:is-expanded="isExpanded"
							:video-url="externalVideoSource"
							video-wrapper-class="c-step-by-step__video"
							:video-id="`${id}-${index}`"
						/>
					</div>
					<div v-else class="c-step-by-step__image-container">
						<img
							class="c-step-by-step__image"
							:src="imageUrl"
							:alt="imageAltText"
						/>
					</div>
				</div>
				<div class="c-step-by-step__item-text">
					<DsText
						class="c-step-by-step__heading-text"
						text-type="heading-lg"
						text-style="medium"
						html-element="h3"
						:id="`heading-${id}-${index}`"
						v-if="isTablet"
					>
						{{ headline }}
					</DsText>
					<DsText
						html-element="div"
						text-type="body-md"
						text-style="regular"
					>
						<div v-html="content"></div>
					</DsText>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import StepByStepVideoItemLoop from './StepByStepVideoItemLoop.vue';
import { DsText } from '@coloplast/design-system';

type StepByStepItem = {
	id: string;
	index: number;
	isExpanded: boolean;
	headline: string;
	externalVideoSource?: string;
	imageUrl?: string;
	imageAltText?: string;
	content: string;
};

const props = defineProps<StepByStepItem>();

const emit = defineEmits<(e: 'expand', index: number) => void>();

const headingId = computed(() => {
	return `heading-${props.id}-${props.index}`;
});

const contentId = computed(() => {
	return `content-${props.id}-${props.index}`;
});

const isDesktop = inject('isDesktop');
const isTablet = inject('isTablet');
</script>
